import styled, { keyframes } from 'styled-components';

const rotateIn = keyframes`
0% {
    -webkit-transform: rotate(0);
            transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
`;

export const HomePage = styled.section`
  display: flex;
  margin-top: 5.5rem;

  @media (max-width: 692px) {
    margin-top: 5rem;
  }
  @media (max-width: 584px) {
    margin-top: 6rem;
  }
  @media (max-width: 545px) {
    margin-top: 8rem;
  }
  @media (max-width: 508px) {
    margin-top: 7rem;
  }
  @media (max-width: 418px) {
    margin-top: 11rem;
  }
  @media (max-width: 390px) {
    margin-top: 14rem;
  }
  @media (max-width: 380px) {
    margin-top: 11rem;
  }
  @media (max-width: 290px) {
    margin-top: 9rem;
  }

  .space-ship {
    position: absolute;
    width: 15rem;
    right: 3rem;
    top: 3rem;
    filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(265deg)
      brightness(105%) contrast(100%);
    -webkit-animation: ${rotateIn} 160s linear infinite normal;
    animation: ${rotateIn} 160s linear infinite normal;
    opacity: 0.3;
    @media (max-width: 900px) {
      right: 8rem;
      top: 5rem;
      width: 14rem;
    }
    @media (max-width: 740px) {
      width: 13rem;
    }
    @media (max-width: 695px) {
      right: 7rem;
      width: 13rem;
    }
    @media (max-width: 508px) {
      right: 3rem;
      width: 12rem;
    }
    @media (max-width: 385px) {
      top: 7rem;
      width: 11.5rem;
    }
    @media (max-width: 355px) {
      width: 9rem;
    }
  }

  .solar-ring {
    border: 2px solid #8d8d8d;
    width: 55rem;
    height: 55rem;
    opacity: 0.2;
    border-radius: 50%;
    position: absolute;
    top: -20rem;
    right: -20rem;
    transform: skew(-7deg, -7deg);
    @media (max-width: 740px) {
      top: -14rem;
      left: 0;
      transform: translateY(-50%), skew(-7deg, -7deg);
    }
    @media (max-width: 580px) {
      width: 45rem;
      height: 45rem;
    }

    &:after {
      content: ' ';
      position: absolute;
      top: -25%;
      left: -25%;
      width: 150%;
      opacity: 0.4;
      border: 2px solid #8d8d8d;
      height: 150%;
      border-radius: 50%;
    }
    &:before {
      content: ' ';
      position: absolute;
      top: 25%;
      left: 25%;
      width: 50%;
      border: 2px solid #8d8d8d;
      opacity: 1;
      height: 50%;
      border-radius: 50%;
    }
  }

  .text-zone {
    max-width: 58rem;
    width: 80%;
    margin-left: 4rem;
    position: relative;
    z-index: 3;
    @media (max-width: 692px) {
      width: 87%;
      margin: auto;
    }

    @media (max-width: 355px) {
      width: 90%;
    }
    h2 {
      font-size: clamp(0.8rem, 2.5vw, 1rem); 
    }
  }

  h1 {
    color: #fff;
    font-size: 3.9rem;
    line-height: 53px;
    margin: 0;
    font-family: 'Lato', sans-serif;
    font-weight: 500;

    @media (max-width: 665px) {
      font-size: 3rem;
    }
    @media (max-width: 588px) {
      font-size: 2.5rem;
    }
    @media (max-width: 500px) {
      font-size: 2rem;
    }
    @media (max-width: 385px) {
      font-size: 1.8rem;
    }
    @media (max-width: 385px) {
      top: 47%;
      left: 13%;
    }
    @media (max-width: 355px) {
      font-size: 1.7rem;
    }
    @media (max-width: 300px) {
      font-size: 1.4rem;
    }

    &:before {
      content: '<h1>';
      font-family: 'La Belle Aurore', cursive;
      color: #3bcfe3;
      opacity: 0.3;
      font-size: 18px;
      position: absolute;
      margin-top: -40px;
      left: -15px;
    }

    &:after {
      content: '<h1/>';
      font-family: 'La Belle Aurore', cursive;
      font-size: 18px;
      position: absolute;
      margin-top: 18px;
      margin-left: 20px;
      animation: fadeIn 1s 1.7s backwards;
      color: #3bcfe3;
      opacity: 0.3;
    }

    img {
      margin-left: 20px;
      opacity: 0;
      width: 32px;
      height: auto;
      animation: rotateIn 1s linear both;
      animation-delay: 1.4s;
    }
  }

  h2 {
    color: #8d8d8d;
    margin-top: 20px;
    font-weight: 400;
    font-size: 11px;
    font-family: sans-serif;
    letter-spacing: 3px;
    animation: fadeIn 1s 1.8s backwards;
  }

  .flat-button {
    color: #3bcfe3;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 4px;
    font-family: sans-serif;
    text-decoration: none;
    padding: 10px 18px;
    display: inline-block;
    border: 1px solid #3bcfe3;
    white-space: nowrap;

    @media (max-width: 400px) {
      margin-top: 40px;
    }

    &:hover {
      color: #333;
    }
  }
`;
